import React from 'react';

const GoddessMechaSui = () => {
  return (
    <div className="container" style={{ 
      padding: '60px 0',
      backgroundColor: '#121212',
      color: '#ffffff',
      minHeight: '100vh'
    }}>
      <div className="container-sm" style={{ maxWidth: '720px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img 
            src="/sui_header.webp" 
            alt="Goddess Mecha with SUI Header" 
            style={{ 
              maxWidth: '100%', 
              borderRadius: '8px'
            }}
          />
        </div>
        
        <h1 className="mt-0 mb-16" style={{ 
          fontSize: '42px',
          lineHeight: '1.2',
          letterSpacing: '-0.025em',
          fontWeight: '600',
          textAlign: 'center',
          marginBottom: '32px',
          color: '#ffffff'
        }}>
          Goddess Mecha with SUI
        </h1>

        <div style={{ 
          margin: '24px 0', 
          fontSize: '18px', 
          lineHeight: '1.5',
          textAlign: 'center',
          color: '#e0e0e0'
        }}>
          <p style={{ marginBottom: '20px' }}>
            The SUI reward feature has been added to Goddess Mecha!
          </p>
          <p style={{ marginBottom: '32px' }}>
            Follow the guide below to connect your SUI wallet address to the app and receive daily SUI rewards!
          </p>
        </div>

        <div style={{ 
          margin: '32px 0',
          padding: '24px',
          backgroundColor: '#1e1e1e',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
          border: '1px solid #333333'
        }}>
          <h3 style={{
            fontSize: '22px',
            fontWeight: '600',
            marginBottom: '16px',
            color: '#ffffff',
            display: 'flex',
            alignItems: 'center'
          }}>
            <span style={{ 
              backgroundColor: '#2196F3', 
              color: 'white', 
              borderRadius: '4px', 
              padding: '2px 6px',
              marginRight: '8px',
              fontSize: '18px'
            }}>
              Step 1
            </span>
            Install SUI Wallet
          </h3>
          <p style={{ fontSize: '16px', marginBottom: '16px', color: '#e0e0e0' }}>
            On your desktop or Mac, install the SUI Wallet extension for the Chrome browser.
          </p>
          <p>
            <a 
              href="https://chromewebstore.google.com/detail/sui-wallet/opcgpfmipidbgpenhmajoajpbobppdil?hl=en-US&utm_source=ext_sidebar" 
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '8px 16px',
                backgroundColor: '#2196F3',
                color: 'white',
                borderRadius: '4px',
                textDecoration: 'none',
                fontWeight: '500',
                marginTop: '8px'
              }}
            >
              <span role="img" aria-label="pointing right">👉</span> SUI Wallet
            </a>
          </p>
        </div>

        <div style={{ 
          margin: '32px 0',
          padding: '24px',
          backgroundColor: '#1e1e1e',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
          border: '1px solid #333333'
        }}>
          <h3 style={{
            fontSize: '22px',
            fontWeight: '600',
            marginBottom: '16px',
            color: '#ffffff',
            display: 'flex',
            alignItems: 'center'
          }}>
            <span style={{ 
              backgroundColor: '#2196F3', 
              color: 'white', 
              borderRadius: '4px', 
              padding: '2px 6px',
              marginRight: '8px',
              fontSize: '18px'
            }}>
              Step 2
            </span>
            Log in to the SUI Wallet & Copy Your Address
          </h3>
          <p style={{ fontSize: '16px', marginBottom: '16px', color: '#e0e0e0' }}>
            After installing the extension, log in to your SUI Wallet and copy your wallet address.
          </p>
          
          <div style={{ textAlign: 'center', margin: '20px 0' }}>
            <img 
              src="/sui_0.webp" 
              alt="SUI Wallet Setup" 
              style={{ 
                maxWidth: '100%', 
                borderRadius: '8px',
                border: '1px solid #333333'
              }}
            />
          </div>
        </div>

        <div style={{ 
          margin: '32px 0',
          padding: '24px',
          backgroundColor: '#1e1e1e',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
          border: '1px solid #333333'
        }}>
          <h3 style={{
            fontSize: '22px',
            fontWeight: '600',
            marginBottom: '16px',
            color: '#ffffff',
            display: 'flex',
            alignItems: 'center'
          }}>
            <span style={{ 
              backgroundColor: '#2196F3', 
              color: 'white', 
              borderRadius: '4px', 
              padding: '2px 6px',
              marginRight: '8px',
              fontSize: '18px'
            }}>
              Step 3
            </span>
            Log in the Game & Enter Your Address
          </h3>
          <p style={{ fontSize: '16px', marginBottom: '16px', color: '#e0e0e0' }}>
            Download and open Goddess Mecha on your device:
          </p>
          
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: '20px',
            margin: '20px 0' 
          }}>
            <a 
              href="https://play.google.com/store/apps/details?id=com.singletongames.xxd" 
              target="_blank"
              rel="noopener noreferrer"
            >
              <img 
                src="/google_play.png" 
                alt="Get it on Google Play" 
                style={{ 
                  height: '50px',
                  borderRadius: '6px'
                }}
              />
            </a>
            <a 
              href="https://apps.apple.com/app/goddess-mecha/id6503224821" 
              target="_blank"
              rel="noopener noreferrer"
            >
              <img 
                src="/app_store.png" 
                alt="Download on the App Store" 
                style={{ 
                  height: '50px',
                  borderRadius: '6px'
                }}
              />
            </a>
          </div>
          
          <div style={{ textAlign: 'center', margin: '20px 0' }}>
            <img 
              src="/tutorial_1.jpg" 
              alt="Goddess Mecha Game Login" 
              style={{ 
                maxWidth: '100%', 
                borderRadius: '8px',
                border: '1px solid #333333'
              }}
            />
          </div>
          
          <p style={{ fontSize: '16px', marginBottom: '16px', color: '#e0e0e0' }}>
            Log in to the game and enter your copied SUI wallet address in the designated field.
          </p>
        </div>

        <div style={{ 
          margin: '32px 0',
          padding: '24px',
          backgroundColor: '#1e1e1e',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
          border: '1px solid #333333'
        }}>
          <h3 style={{
            fontSize: '22px',
            fontWeight: '600',
            marginBottom: '16px',
            color: '#ffffff',
            display: 'flex',
            alignItems: 'center'
          }}>
            <span style={{ 
              backgroundColor: '#2196F3', 
              color: 'white', 
              borderRadius: '4px', 
              padding: '2px 6px',
              marginRight: '8px',
              fontSize: '18px'
            }}>
              Step 4
            </span>
            Participate in Daily Boss Raid
          </h3>
          <p style={{ fontSize: '16px', marginBottom: '16px', color: '#e0e0e0' }}>
            To earn SUI rewards, you need to participate in the Daily Boss Raid event in Goddess Mecha. 
            This exciting feature allows you to earn SUI tokens while enjoying the game!
          </p>
          
          <div style={{ textAlign: 'center', margin: '20px 0' }}>
            <img 
              src="/tutorial_2.jpg" 
              alt="Daily Boss Raid" 
              style={{ 
                maxWidth: '100%', 
                borderRadius: '8px',
                border: '1px solid #333333'
              }}
            />
          </div>
          
          <div style={{ 
            backgroundColor: '#31273b', 
            borderRadius: '6px', 
            padding: '16px', 
            marginTop: '24px',
            border: '1px solid #523d68'
          }}>
            <p style={{ 
              color: '#c688fc', 
              margin: '0', 
              display: 'flex', 
              alignItems: 'flex-start',
              fontSize: '15px',
              lineHeight: '1.5'
            }}>
              <span style={{ 
                display: 'inline-block', 
                marginRight: '10px',
                minWidth: '22px',
                height: '22px',
                borderRadius: '50%',
                backgroundColor: '#c688fc',
                color: '#31273b',
                textAlign: 'center',
                fontWeight: 'bold',
                lineHeight: '22px',
                marginTop: '2px'
              }}>!</span>
              <span>
                <strong>IMPORTANT:</strong> Daily Boss Raids reset every day at 00:00 UTC. Higher ranks offer better SUI rewards!
              </span>
            </p>
          </div>
        </div>

        <div style={{ 
          margin: '32px 0',
          padding: '24px',
          backgroundColor: '#1e1e1e',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
          border: '1px solid #333333'
        }}>
          <h3 style={{
            fontSize: '22px',
            fontWeight: '600',
            marginBottom: '16px',
            color: '#ffffff',
            display: 'flex',
            alignItems: 'center'
          }}>
            <span style={{ 
              backgroundColor: '#2196F3', 
              color: 'white', 
              borderRadius: '4px', 
              padding: '2px 6px',
              marginRight: '8px',
              fontSize: '18px'
            }}>
              Step 5
            </span>
            Receive Your SUI Rewards
          </h3>
          <p style={{ fontSize: '16px', marginBottom: '16px', color: '#e0e0e0' }}>
            After participating in the Daily Boss Raids, you can claim your accumulated SUI rewards through our dedicated reward portal.
          </p>
          
          <div style={{ textAlign: 'center', margin: '24px 0' }}>
            <a 
              href="https://sui.singletongames.co" 
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '10px 20px',
                backgroundColor: '#2196F3',
                color: 'white',
                borderRadius: '4px',
                textDecoration: 'none',
                fontWeight: '500',
                fontSize: '16px'
              }}
            >
              <span role="img" aria-label="pointing right">👉</span> Reward Portal
            </a>
          </div>
          
          <div style={{ textAlign: 'center', margin: '24px 0' }}>
            <img 
              src="/tutorial_3.jpg" 
              alt="Claim SUI Rewards" 
              style={{ 
                maxWidth: '100%', 
                borderRadius: '8px',
                border: '1px solid #333333'
              }}
            />
          </div>
          
        </div>

        <div style={{
          padding: '0px',
          backgroundColor: '#1e1e1e',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
          border: '1px solid #333333',
          textAlign: 'center'
        }}>
          <h3 style={{
            fontSize: '20px',
            fontWeight: '600',
            marginBottom: '16px',
            color: '#ffffff'
          }}>
            Need Help?
          </h3>
          <p style={{ fontSize: '16px', marginBottom: '20px', color: '#e0e0e0' }}>
            Feel free to ask if you need further assistance or have any questions!
          </p>
          <a 
            href="mailto:help@singletongames.co"
            style={{
              color: '#4dabf7',
              textDecoration: 'none',
              fontWeight: '500',
              fontSize: '16px'
            }}
          >
            help@singletongames.co
          </a>
          <p style={{ fontSize: '16px', marginBottom: '40px', color: '#e0e0e0' }}></p>
        </div>
      </div>
    </div>
  );
};

export default GoddessMechaSui; 